<template>
  <footer id="footer" class="page-footer">
    <div>
      <div class="copy" v-html="$t('lang.footer.label_company')"></div>
      <nav>
        <ul>
          <li>
            <a href="https://bionixsolutions.com/platform/">{{
              $t("lang.footer.label_link")
            }}</a>
          </li>
          <li>
            <router-link to="/legal">{{
              $t("lang.footer.label_legal")
            }}</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: "web-footer"
};
</script>
